import type { Ruleset } from '@brig/rules-engine';
import { useTranslation } from 'react-i18next';
import type { HintKey } from './firstHints.ts';
import * as css from './HintCard.css.ts';
import { topicNumbers } from './topics.ts';

/**
 * A first-time hint (docs/ux.md U-LEARN-06): one or two sentences, "More…" to its page of
 * "How to play", and "Got it". It asks nothing: the game goes on around it.
 */
export function HintCard({
  hint,
  ruleset,
  onMore,
  onDismiss,
}: {
  hint: HintKey;
  ruleset: Ruleset;
  onMore: () => void;
  onDismiss: () => void;
}) {
  const { t } = useTranslation();
  return (
    <aside className={css.card} aria-labelledby="first-hint-title" data-testid="first-hint" data-hint={hint}>
      <p id="first-hint-title" className={css.title}>
        {t(`learn.hints.${hint}.title`)}
      </p>
      <p className={css.text}>{t(`learn.hints.${hint}.body`, topicNumbers(ruleset))}</p>
      <div className={css.actions}>
        <button type="button" className={css.more} onClick={onMore}>
          {t('learn.hintMore')}
        </button>
        <button type="button" className={css.gotIt} onClick={onDismiss}>
          {t('learn.hintGotIt')}
        </button>
      </div>
    </aside>
  );
}
